import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import DocumentEditor from 'notebook/documents/DocumentEditor';
import {GRAY_LIGHT, WHITE} from 'ui-library/Colors';

import {DraftDocument} from './DataCaptureTypes';

export interface DataCaptureDraftDocumentProps {
  draftDocument: DraftDocument;
}

export function DataCaptureDraftDocument({draftDocument}: DataCaptureDraftDocumentProps): JSX.Element {
  const documentId = draftDocument.document_api_identifier;

  return (
    <div className={css(styles.documentContainer)} data-testid="draft-document-container">
      <div className={css(styles.documentHeader)} data-testid="draft-document-header">
        <h3>Draft Document</h3>
      </div>
      <div className={css(styles.documentContent)} data-testid="draft-document-content">
        <DocumentEditor
          id={documentId}
          locked={true}
          disableInternalAutoSaver={true}
          viewer={true}
          disableFormatting={true}
        />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  documentContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: WHITE,
    border: `1px solid ${GRAY_LIGHT}`,
    borderRadius: '8px',
    padding: '4px',
  },
  documentHeader: {
    padding: '16px',
    borderBottom: `1px solid ${GRAY_LIGHT}`,
    backgroundColor: WHITE,
  },
  documentContent: {
    flex: 1,
    padding: '4px',
    overflowY: 'auto',
  },
});
